import React from 'react';

const ICONS: Record<string, string> = {
  'check': 'M5 12l5 5L20 7',
  'x': 'M6 6l12 12M18 6 6 18',
  'plus': 'M12 5v14M5 12h14',
  'minus': 'M5 12h14',
  'chev-l': 'm15 6-6 6 6 6',
  'chev-r': 'm9 6 6 6-6 6',
  'chev-d': 'm6 9 6 6 6-6',
  'chev-u': 'm6 15 6-6 6 6',
  'arrow-r': 'M5 12h14m-6-6 6 6-6 6',
  'arrow-l': 'M19 12H5m6 6-6-6 6-6',
  'search': 'M11 4a7 7 0 1 1-4.95 11.95M21 21l-4.3-4.3',
  'edit': 'M12 20h9M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4z',
  'trash': 'M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6',
  'settings': 'M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM19 12c0-.4 0-.8-.1-1.2l2-1.6-2-3.4-2.4.9c-.6-.5-1.3-.9-2-1.2L14 3h-4l-.5 2.5c-.7.3-1.4.7-2 1.2l-2.4-.9-2 3.4 2 1.6c-.1.4-.1.8-.1 1.2s0 .8.1 1.2l-2 1.6 2 3.4 2.4-.9c.6.5 1.3.9 2 1.2L10 21h4l.5-2.5c.7-.3 1.4-.7 2-1.2l2.4.9 2-3.4-2-1.6c.1-.4.1-.8.1-1.2z',
  'user': 'M4 21c0-4 4-7 8-7s8 3 8 7M12 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8z',
  'users': 'M2 21c0-4 3-6 7-6s7 2 7 6M9 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM17 14c3 0 6 2 6 6M17 11a3 3 0 1 0 0-6',
  'calendar': 'M3 5h18v16H3zM3 9h18M8 3v4M16 3v4',
  'clock': 'M12 7v5l3 2M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z',
  'bell': 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21a2 2 0 0 0 4 0',
  'mail': 'M3 6h18v12H3zM3 6l9 7 9-7',
  'lock': 'M5 11h14v10H5zM8 11V8a4 4 0 1 1 8 0v3',
  'unlock': 'M5 11h14v10H5zM8 11V8a4 4 0 0 1 7.5-1.6',
  'external': 'M14 4h6v6M20 4 10 14M20 14v6H4V4h6',
  'filter': 'M3 5h18l-7 8v7l-4-2v-5z',
  'download': 'M12 3v12m0 0 4-4m-4 4-4-4M4 17v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3',
  'upload': 'M12 21V9m0 0 4 4m-4-4-4 4M4 7V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3',
  'info': 'M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 8v.01M12 11v5',
  'warn': 'M12 3 2 21h20L12 3zM12 10v4M12 18v.01',
  'more': 'M5 12h.01M12 12h.01M19 12h.01',
  'menu': 'M4 6h16M4 12h16M4 18h16',
  'home': 'M3 11l9-8 9 8M5 10v11h14V10',
  'star': 'M12 3l3 6.5 7 1-5 5 1.2 7L12 19l-6.2 3.5L7 15l-5-5 7-1z',
  'eye': 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
  'eye-off': 'M3 3l18 18M10.6 5.2A10.4 10.4 0 0 1 12 5c6 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4M6.6 6.6C4 8.3 2 12 2 12s4 7 10 7c1.3 0 2.5-.3 3.6-.8M9.5 9.5a3 3 0 0 0 4.2 4.2',
  'copy': 'M9 3h11v14H9zM4 7v14h13',
  'folder': 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  'folder-plus': 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM12 11v5M9.5 13.5h5',
  'file': 'M14 3v5h5M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z',
  'image': 'M4 5h16v14H4zM4 16l4.5-4.5 3 3 4-4L20 14M9 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z',
  'video': 'M15 10l5-3v10l-5-3v-4zM4 7h11v10H4z',
  'music': 'M9 18V5l12-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM21 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0z',
  'archive': 'M3 4h18v4H3zM3 8h18v14H3zM10 12h4',
  'share': 'M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98',
  'link': 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
  'grid': 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  'list': 'M3 6h18M3 12h18M3 18h18',
  'sort': 'M3 6h18M7 12h10M11 18h2',
  'move': 'M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20',
  'send': 'M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z',
  'refresh': 'M23 4v6h-6M1 20v-6h6M3.5 9A9 9 0 0 1 20.5 9M20.5 15A9 9 0 0 1 3.5 15',
  'tag': 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01',
  'chart': 'M18 20V10M12 20V4M6 20v-6',
  'shield': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  'shield-check': 'M12 3l8 3v6c0 5-3.4 8-8 9-4.6-1-8-4-8-9V6zM9 12l2 2 4-4',
  'database': 'M12 8c4.97 0 9-1.12 9-2.5S16.97 3 12 3 3 4.12 3 5.5 7.03 8 12 8zM3 5.5v11C3 17.88 7.03 19 12 19s9-1.12 9-2.5V5.5M3 12c0 1.38 4.03 2.5 9 2.5s9-1.12 9-2.5',
  'log-out': 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  'trending': 'M23 6l-9.5 9.5-5-5L1 18',
  'trend': 'M3 17l6-6 4 4 7-7M14 8h6v6',
  'inbox': 'M3 13h5l1 3h6l1-3h5M3 13l3-9h12l3 9v6H3z',
  'hdd': 'M4 13h16M5 13l2-8h10l2 8v6H5zM8 16h.01M12 16h.01',
  'zap': 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
  'sparkle': 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z',
  'hard-drive': 'M22 12H2M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 17.76 4H6.24a2 2 0 0 0-1.79 1.11zM6 16h.01M10 16h.01',
  'cpu': 'M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18',
  'layers': 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
  'cloud': 'M18 10a6 6 0 0 0-11.83-1.22A5 5 0 0 0 7 19h11a4 4 0 0 0 0-8z',
  'crown': 'M4 8l4.5 3.5L12 5l3.5 6.5L20 8l-1.5 9h-13L4 8zM5.5 17h13',
};

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

export default function Icon({ name, size = 16, color, style, className = '' }: IconProps) {
  const d = ICONS[name];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || 'currentColor'}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      className={className}
      aria-hidden="true"
    >
      {d ? <path d={d} /> : <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />}
    </svg>
  );
}
